import { memo } from 'react';
import Div from '../Div';
import Image from '@/shared/Image';
import dlv from 'dlv';

const ProductSizingWidget = (image: any) => {
  let imageUrl = dlv(image, 'image.data.attributes.url');
  return (
    <Div className="h-auto flex flex-1 px-s6 py-s5 mb-s3 md:mb-0 items-start self-stretch rounded-cm overflow-hidden bg-cs-primary">
      {imageUrl && (
        <Image
          alt={'Sizing Card Image'}
          src={imageUrl}
          className="h-full w-full object-contain"
          width={400}
          height={400}
        />
      )}
    </Div>
  );
};

export default memo(ProductSizingWidget);
